<!-- Chargement -->
<app-loading *ngIf="loading"></app-loading>

<!-- Erreur -->
<div *ngIf="error && !loading" class="gallery-detail__error container">
    <i class="icofont-warning-alt"></i>
    <p>{{ error | translate }}</p>
    <a [routerLink]="['/galerie']" class="careox-btn">{{ 'galerie_retour' | translate }}</a>
</div>

<ng-container *ngIf="gallery && !loading">

    <!-- ── En-tête ──────────────────────────────────────────────────── -->
    

    <section class="cuspage-hero">
        <div class="cuspage-hero__bg"  ></div>
        <div class="container">
            <div class="cuspage-hero__content">
                <span class="cuspage-hero__tagline" style="display:none;">
                    <i class="icofont-justice-hammer"></i>
                    {{ 'galerie_titre' | translate }}
                </span>
                <h1 class="cuspage-hero__title">{{ gallery.name }} </h1>
                <p class="cuspage-hero__sub">{{ 'galerie_titre' | translate }} </p>  
            </div>
        </div>
    </section>

    <!-- ── Infos galerie ────────────────────────────────────────────── -->
    <section class="gallery-detail">
        <div class="container">

            <!-- Méta -->
            <div class="gallery-detail__meta">
                <span class="gallery-detail__badge"
                      [class.gallery-detail__badge--video]="gallery.type === 'video'">
                    <i [class]="gallery.type === 'video' ? 'icofont-video-alt' : 'icofont-image'"></i>
                    {{ (gallery.type === 'video' ? 'galerie_type_video' : 'galerie_type_image') | translate }}
                </span>
                <span class="gallery-detail__views">
                    <i class="icofont-eye-alt"></i> {{ gallery.views }} {{ 'galerie_vues' | translate }}
                </span>
                <span class="gallery-detail__count">
                    <i class="icofont-image"></i>
                    {{ gallery.gallery.length }} {{ 'galerie_medias' | translate }}
                </span>
            </div>

            <!-- Description -->
            <p *ngIf="gallery.description" class="gallery-detail__desc">
                {{ gallery.description }}
            </p>

            <!-- ── Grille des médias ──────────────────────────────── -->
            <div *ngIf="gallery.gallery?.length; else emptyGallery"
                 class="gallery-detail__grid">

                <!-- Images -->
                <ng-container *ngFor="let media of gallery.gallery; let i = index">

                    <!-- Vidéo -->
                    <div *ngIf="isVideo(media)"
                         class="gallery-detail__item gallery-detail__item--video wow fadeInUp"
                         [attr.data-wow-duration]="'800ms'"
                         [attr.data-wow-delay]="getDelay(i)">
                        <video controls [src]="media.url" class="gallery-detail__video"
                               preload="metadata">
                            {{ 'galerie_video_non_supporte' | translate }}
                        </video>
                    </div>

                    <!-- Image avec lightbox -->
                    <div *ngIf="!isVideo(media)"
                         class="gallery-detail__item wow fadeInUp"
                         [attr.data-wow-duration]="'800ms'"
                         [attr.data-wow-delay]="getDelay(i)">
                        <img [src]="media.thumb || media.url"
                             [alt]="gallery.name + ' ' + (i + 1)"
                             loading="lazy">
                        <!-- Lien Magnific Popup -->
                        <a class="gallery-detail__popup gallery-detail__hover"
                           [href]="media.url"
                           [title]="gallery.name + ' — ' + (i + 1)"
                           (click)="openLightbox(i); $event.preventDefault()">
                            <span class="gallery-detail__hover-icon">
                                <i class="icofont-expand"></i>
                            </span>
                        </a>
                    </div>

                </ng-container>
            </div>

            <ng-template #emptyGallery>
                <div class="gallery-detail__empty">
                    <i class="icofont-image"></i>
                    <p>{{ 'galerie_vide' | translate }}</p>
                </div>
            </ng-template>

            <!-- Retour -->
            <div class="gallery-detail__back">
                <a [routerLink]="['/galerie']" class="careox-btn careox-btn--white">
                    <i class="icofont-arrow-left"></i> {{ 'galerie_retour' | translate }}
                </a>
            </div>

        </div>
    </section>

</ng-container>

<!-- ── Lightbox maison ──────────────────────────────────────────────── -->
<div class="lightbox-overlay" *ngIf="lightboxOpen" (click)="closeLightbox()">
    <button class="lightbox-close" (click)="closeLightbox()">
        <i class="icofont-close"></i>
    </button>
    <button class="lightbox-prev" (click)="prevMedia(); $event.stopPropagation()">
        <i class="icofont-double-left"></i>
    </button>
    <div class="lightbox-content" (click)="$event.stopPropagation()">
        <ng-container *ngIf="currentMedia">
            <video *ngIf="isVideo(currentMedia)" controls [src]="currentMedia.url" class="lightbox-media"></video>
            <img *ngIf="!isVideo(currentMedia)" [src]="currentMedia.url" class="lightbox-media" alt="">
        </ng-container>
        <p class="lightbox-counter">
            {{ lightboxIndex + 1 }} / {{ gallery?.gallery?.length }}
        </p>
    </div>
    <button class="lightbox-next" (click)="nextMedia(); $event.stopPropagation()">
        <i class="icofont-double-right"></i>
    </button>
</div>
